export const ROUTES = {
    FORGOT_PASSWORD: '/auth/forgot-password',
};
